import { FlexContainer } from '@/ui/styled-ui';
import { AppSwitch } from '@/ui/switch/AppSwitch';
import classNames from 'classnames';
import { InputSwitchProps } from 'primereact/inputswitch';
import { Tooltip } from 'primereact/tooltip';
import React from 'react';
import styled from 'styled-components';
import { FormikSwitchProps } from './FormikSwitch';

const StyledLabel = styled.label`
  font-size: var(--small-font-size);
  line-height: var(--small-line-height);
  font-weight: 500;
  margin-bottom: 0 !important;
  margin-left: 0 !important;
`;

const StyledIcon = styled.i`
  font-size: var(--xsmall-font-size);
  color: var(--gray-darker);
  cursor: pointer;
`;

export const FormikWrappedSwitch: React.FC<
  FormikSwitchProps & InputSwitchProps
> = ({
  field,
  form,
  label,
  required,
  className,
  tooltip,
  tooltipId,
  tooltipStyle,
  ...rest
}) => (
  <FlexContainer
    justify="space-between"
    className="w-full"
    style={{ position: 'relative' }}
  >
    <StyledLabel
      htmlFor={field.name}
      className={classNames({
        'p-error': !!form.errors[field.name],
      })}
    >
      {label}
      {required ? <span className="red"> *</span> : ''}
      {tooltip && tooltipId && (
        <>
          <Tooltip
            target={`#${tooltipId}`}
            position="top"
            my="center bottom-10"
            style={tooltipStyle}
          >
            {tooltip}
          </Tooltip>
          <StyledIcon className="pi pi-info-circle ml-1" id={tooltipId} />
        </>
      )}
    </StyledLabel>
    <AppSwitch
      {...field}
      {...rest}
      checked={!!field.value}
      className={className}
    />
  </FlexContainer>
);
